import { FC, useContext } from 'react';

import {
  ICompetitionEvents,
  IMultisportConfigEntityLinks,
  ISubscriberInfoFn,
  SDKDateOptions,
  SportTypes,
} from '../../../../../packages/types';
import SportEvent from './SportEvent';
import { Competition } from './Competition';
import { IMultisportEventsLabels, getMultisportEventsLabels } from '../../utils/getMultisportLabels';
import { getCompetitionLink, getGompetitionEventLink } from '../../utils/getCompetitionLink';
import { ConfigContext, ConfigContextType } from '../../../../../packages/ui/dist';

interface CompetitionListProps {
  competition: ICompetitionEvents;
  topEventsSelected?: boolean;
  dataEntityLinks: IMultisportConfigEntityLinks | null | undefined;
  sdkDateOptions: SDKDateOptions;
  handleClick: ISubscriberInfoFn;
}

export const CompetitionList: FC<CompetitionListProps> = ({
  competition,
  topEventsSelected,
  dataEntityLinks,
  sdkDateOptions,
  handleClick,
}) => {
  const { dataShowCompetitionNames, dataLabels, dataOddsDisplay, dataOddsBettingId } = useContext<ConfigContextType>(ConfigContext);
  const labels = getMultisportEventsLabels(dataLabels);
  const displayOdds = dataOddsDisplay === true && dataOddsBettingId !== undefined && dataOddsBettingId !== null;

  // Participants are added only on events where the Sport Event displays the participant - like cycling. If no participants are present we don't want to display the competition.
  if (competition.events.length > 0 && competition.events[0].participants?.length === 0) return null;

  const competitionLinkData = getCompetitionLink(
    competition.competition.sport as SportTypes,
    competition.competition.legacyId || competition.competition.id, // LegacyId is used for football, other sports should NOT have a legacyId
    competition.competition.slug,
    dataEntityLinks,
  );

  return (
    <>
      {topEventsSelected && dataShowCompetitionNames && (
        <Competition
          link={competitionLinkData.competitionLink}
          target={competitionLinkData.urlTarget}
          logo={competition.competition.logoUrl}
          subText={topEventsSelected ? labels[competition.competition.sport as keyof IMultisportEventsLabels] : null}
          name={competition.competition.name}
          id={competition.competition.id}
          handleClick={handleClick}
        />
      )}
      {competition.events.map((event, index) => {
        const eventLinkData = getGompetitionEventLink(competition.competition.sport as SportTypes, event, dataEntityLinks);
        return (
          <SportEvent
            competitionLogo={competition.competition.logoUrl}
            key={index}
            topEventsSelected={topEventsSelected}
            sport={competition.competition.sport as SportTypes}
            event={event}
            labels={labels}
            eventLink={eventLinkData.eventLink}
            target={eventLinkData.urlTarget}
            sdkDateOptions={sdkDateOptions}
            displayOdds={displayOdds}
            handleClick={handleClick}
          />
        );
      })}
    </>
  );
};
